var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import classNames from 'classnames';
import { makeStyles, clickableStyle } from "../../styles/index";
import { useTheme } from "../../hooks/useTheme";
import { useLink } from "../../hooks/useLink";
var useStyles = makeStyles(function (theme) { return ({
    root: __assign(__assign({}, clickableStyle(theme)), { width: 48, height: 48, border: 0, borderRadius: theme.shape.borderRadius, backgroundColor: 'transparent', display: 'inline-flex', alignItems: 'center', outline: 0, padding: 0 }),
    light: {
        color: 'inherit',
    },
    dark: {
        color: theme.palette.dark.text.primary,
    },
    disabled: {
        color: theme.palette.text.hint,
        pointerEvents: 'none',
    },
}); }, { name: 'SnIconButton' });
export var IconButton = React.forwardRef(function (props, ref) {
    var _a;
    var to = props.to, href = props.href, isTargetBlank = props.isTargetBlank, disabled = props.disabled;
    var type = useTheme(props).type;
    var classes = useStyles(props);
    var LinkComponent = useLink({ to: to, href: href, isTargetBlank: isTargetBlank });
    var hasLink = to || href;
    var className = classNames(classes.root, classes[type], (_a = {}, _a[classes.disabled] = disabled, _a), props.className);
    var handleClick = function (event) {
        var _a;
        (_a = props.onClick) === null || _a === void 0 ? void 0 : _a.call(props, event);
    };
    return (React.createElement(React.Fragment, null, hasLink ? (React.createElement(LinkComponent, { ref: ref, className: className }, props.children)) : (React.createElement("button", { ref: ref, className: className, onClick: handleClick, disabled: disabled }, props.children))));
});
